export const AppointmentStatus = {
  Pending: "PENDING",
  Approved: "APPROVED",
  Rejected: "REJECTED",
  Done: "DONE",
  Canceled: "CANCELED",
};
